<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-4">
      <h2>{{$t('CONTENT.contract.contract_events_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeContractEditingDialog">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <div class="b-form__container col-5">
        <label>{{$t('CONTENT.contract.contract_events_editing_type')}}:</label>
        <cool-select :list="events"
                     option-value="id"
                     option-text="value"
                     :placeholder="$t('CONTENT.choose')"
                     v-model="currentEvent"/>
      </div>
      <div v-if="currentEvent === 1" class="row mt-7">
        <div class="col-4">
          <div class="col-10">
            <label>{{$t('CONTENT.contract.current_counterparty')}}:</label>
            <input
              v-for="(counterparty, i) in contract.lessorCounterpartyIds"
              :key="i"
              data-cy="counterparty"
              type="text"
              class="b-input mb-4"
              name="counterparty"
              disabled
              :value="getLesseeName(counterparty)"/>
          </div>
        </div>
        <div class="col-3">
          <div class="b-form__container col-15">
            <label>{{$t('CONTENT.contract.new_counterparty')}}:</label>
            <cool-select
              v-for="(counterparty, i) in formData.changedCounterparties"
              :key="i"
              class="mb-4"
              :list="counterparties"
              option-value="id"
              option-text="value"
              :placeholder="$t('CONTENT.choose')"
              v-model="formData.changedCounterparties[i].newLessorId"/>
          </div>
        </div>
        <div class="col-5">
        <label>{{$t('CONTENT.contract.external_id_share_new_counterparty')}}:</label>
        <input
          v-for="(counterparty, i) in formData.changedCounterparties"
          :key="i"
          data-cy="new-share-id"
          type="text"
          class="b-input mb-4"
          name="newShareId"
          v-model="formData.changedCounterparties[i].newLessorComponentShareExternalId"
        />
        </div>
      </div>
      <div v-if="currentEvent === 2" class="row mt-9">
        <div class="col-12">
          <div class="b-form__container col-5">
            <div class="col-8 mb-3 pl-0 ">
              <label>{{ $t('CONTENT.contract.event_date') }}:<span class="b-form__required"> *</span></label>
              <datepicker class="b-datepicker" v-model="formData.newLessor.eventDate" :formatter="datepickerFormat"></datepicker>
            </div>
            <label>{{$t('CONTENT.contract.new_counterparty')}}:<span class="b-form__required"> *</span></label>
            <cool-select
              class="mb-4"
              :list="counterparties"
              option-value="id"
              option-text="value"
              :placeholder="$t('CONTENT.choose')"
              v-model="formData.newLessor.value"/>
          </div>
        </div>
      </div>

      <div v-if="currentEvent === 3" class="row mt-9">
        <div class="col-12">
          <div class="b-form__container col-5">
            <label>{{$t('CONTENT.contract.delete_counterparty')}}:</label>
            <cool-select
              class="mb-4"
              :list="currentCounterparties"
              option-value="id"
              option-text="value"
              :placeholder="$t('CONTENT.choose')"
              v-model="formData.removeLessor"/>
          </div>
        </div>
      </div>

      <div v-if="currentEvent" class="row mt-5">
        <div class="col-12">
          <div class="b-form__container b-form__container_type_flex b-form__container_type_flex_end">
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              :disabled="saveButtonDisabled"
              @click="onSubmit">
              {{$t('CONTENT.save')}}
            </button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="closeContractEditingDialog">
              {{$t('CONTENT.cancel')}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';

  export default {
    mixins: [datepickerFormat],
    props: {
      contract: {
        type: Object
      },
    },
    data() {
      return {
        validationErrors: [],
        currentEvent: null,
        formData: {
          changedCounterparties: [],
          newLessor: {
            eventDate: null,
            value: null,
          },
          removeLessor: null,
        },
      };
    },
    computed: {
      ...mapGetters(["getCounterpartiresForContract"]),
      ...mapGetters(["allCounterparties"]),
      counterparties() {
        return this.getCounterpartiresForContract;
      },
      events() {
        return [
          { id: 1, value: 'Замена арендодателя' },
          { id: 2, value: 'Добавление арендодателя' },
          { id: 3, value: 'Удаление арендодателя' },
        ]
      },
      currentCounterparties() {
        return this.contract.lessorCounterpartyIds.map(id => ({ id, value: this.getLesseeName(id) }));
      },
      saveButtonDisabled() {
        if (this.currentEvent === 1 && !this.formData.changedCounterparties.find(elem => elem.newLessorId !== elem.lessorId)) {
          return true;
        }

        if (this.currentEvent === 2 && (!this.formData.newLessor.value || !this.formData.newLessor.eventDate)) {
          return true;
        }

        if (this.currentEvent === 3 && !this.formData.removeLessor) {
          return true;
        }
        return false;
      }
    },
    watch: {
      currentEvent: {
        handler(value) {
          if (value === 1) {
            this.formData.changedCounterparties = []
            this.contract.lessorCounterpartyIds.forEach((id) => {
              this.formData.changedCounterparties.push({ lessorId: id, newLessorId: id });
            });
          }
        }
      }
    },
    methods: {
      closeContractEditingDialog() {
        this.$store.commit('CLEAR_RENAME_LESSOR_LIST');
        this.$emit("close");
        this.formData = _.cloneDeep(this.contract);
      },
      onSubmit(e) {
        e.preventDefault()

        this.formData.changedCounterparties = this.formData.changedCounterparties
          .filter(changedCounterparty => changedCounterparty.newLessorId !== changedCounterparty.lessorId)

        this.$emit('onSaveEditing', this.formData);
        this.formData.changedCounterparties = [];
        this.formData.newLessor.value = null;
        this.formData.newLessor.eventDate = null;
        this.formData.removeLessor = null;
        this.$emit("close");
      },
      getLesseeName(lesseeId) {
        for (let i = 0; i < this.allCounterparties.length; i++) {
          if(this.allCounterparties[i].idInDB === lesseeId) {
            return this.allCounterparties[i].displayName;
          }
        }
      }
    }
  };
</script>
